exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".new-tag{font-size:12px;line-height:16px;font-weight:bold;background-color:#00bf6f;border-top-right-radius:4px;border-top-left-radius:4px;color:#f5f7f7;padding:0 8px;width:fit-content;display:flex;justify-content:center;align-items:center}", ""]);
// Exports
exports.locals = {
	"medium": "768px",
	"large": "1024px",
	"xlarge": "1440px"
};